import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/global.scss";
// import HomeRoute from "./routes/HomeRoute"

ReactDOM.render(
  <React.StrictMode>
    <App />
    {/* <HomeRoute /> */}
  </React.StrictMode>,
  document.getElementById("root")
);
